import $ from 'jquery';

export default function(API) {
  
	// Multipass
	if ($('body').hasClass('masterpass')) {

		API.log('INIT Masterpass');    
		API.cookie.set('mpCampaignVisited', 1, { expires: 31 });
	}
}
